import styled from 'styled-components';
import { ThemeInterface } from '../../interfaces/themeInterface';

const getOppositeBackground = (theme: ThemeInterface) =>
  theme.name === 'long' ? 'blue' : '#ffccd5';

const getOppositeText = (theme: ThemeInterface) => (theme.name === 'long' ? 'white' : 'black');

export const Banner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 48px;
  background: ${({ theme }) => getOppositeBackground(theme)};
  border-bottom: 1px solid ${({ theme }) => theme.primary};
  color: ${({ theme }) => getOppositeText(theme)};
  z-index: 1001;
  font-size: 0.7rem;
  font-family: monospace;
`;

export const LeftActions = styled.div`
  display: flex;
  align-items: center;
`;

export const RightActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 120px;
`;

export const TierBadge = styled.span`
  letter-spacing: 0.1em;
  opacity: 0.8;
`;

export const Countdown = styled.span`
  font-variant-numeric: tabular-nums;
  opacity: 0.7;
  margin-left: 0.75rem;
`;

export const UpgradeLink = styled.button`
  background: none;
  border: none;
  color: inherit;
  font-size: 0.65rem;
  font-family: monospace;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  margin-left: 1rem;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;
